import LsdApiModel from './global/LsdApiModel';

export default class MercureTokenModel extends LsdApiModel {
	static get path(): string {
		return '/users/mercure/token';
	}
}
